<template>
  <div class="relative h-vh-100">
    <!--  固定位搜索栏  -->
    <van-search class="fixed width-99 z-99" clearable shape="round" v-model="queryData.customerCompanyName" show-action
                @search="onSearch" placeholder="请输入客户名称查询">
      <template #action>
        <div class="w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center" @click="onSearch">搜索</div>
      </template>
    </van-search>
    <!--  站位盒子  -->
    <div class="h-110"></div>
    <!-- 固定按钮 -->
    <!-- 添加 -->
    <div class="zjm-fixed-bottom pos-b-140 pos-r-20 bg-FFDB43 cor-00 font-50" @click="onAddClick">+</div>
    <!-- 返回 -->
    <div class="zjm-fixed-bottom pos-b-20 pos-r-20 bg-FFDB43 cor-FF font-28" @click="goBack">返回</div>

    <!-- 列表 -->
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
          v-model="pageLoading"
          :finished="pageFinished"
          finished-text=" - 没有更多了 - "
          @load="onLoad">
        <van-row @click="detail(item.id)" class="task-block border-8 m-10 p-5 bg-FF" align="center"
                 v-for="item in messageList" :key="item.id">
          <van-col span="24" class="p-20 m-t-10">
            <van-row type="flex" align="center" justify="center">
              <van-col span="3">
                <van-icon class="p-t-20" size="30" name="friends" color="#FFDA3E"/>
              </van-col>
              <van-col span="19">
                <div class="sender-info">
                  <span class="cor-33 font-30 font-weight-600">{{ item.customerCompanyName }}</span>
                </div>
              </van-col>
            </van-row>
            <van-row class="m-t-1" type="flex" align="center" justify="center">
              <van-col span="6">
                <span class="cor-88 font-28">拜访人</span>
              </van-col>
              <van-col span="18">
                <span class="cor-33 font-28">{{ item.customerUserName }}</span>
              </van-col>
            </van-row>
            <van-row class="m-t-1" type="flex" align="center" justify="center">
              <van-col span="6">
                <span class="cor-88 font-28">拜访时间</span>
              </van-col>
              <van-col span="18">
                <span class="cor-33 font-28">{{ item.visitTime }}</span>
              </van-col>
            </van-row>
            <van-row class="m-t-1" type="flex" align="top" justify="center">
              <van-col span="6">
                <span class="cor-88 font-28">拜访记录</span>
              </van-col>
              <van-col span="18">
                <span class="cor-33 font-28 hjj">{{ item.visitGoal }}</span>
              </van-col>
            </van-row>
            <van-divider class="divider-small"></van-divider>

            <van-row type="flex" align="center" justify="center">
              <van-col span="18">
                <span class="font-28 cor-00">记录：</span>
                <span class="font-28 cor-00">{{ item.createByName }} {{ convertTime(item.createTime) }}</span>
              </van-col>
            </van-row>
          </van-col>
        </van-row>

      </van-list>

    </van-pull-refresh>


  </div>
</template>
<script>
import {Cell, CellGroup, Col as VanCol, Image as VanImage, List as VanList, Row as VanRow, Search} from 'vant';
import {getCustomerVisitAPI} from '@/api/visit.js';

export default {
  components: {
    VanCell: Cell,
    VanCellGroup: CellGroup,
    VanImage: VanImage,
    VanSearch: Search,
    VanList: VanList,
    VanRow: VanRow,
    VanCol: VanCol
  },
  data() {
    return {
      searchValue: '',
      messageList: [],
      refreshLoading: false,
      pageLoading: false,
      pageFinished: false,
      queryData: {
        customerCompanyName: '',
        pageNum: 1, // 当前页码
        pageSize: 10 // 每页条数
      },

    };
  },
  created() {
    this.onLoad();
  },

  methods: {
    onClear() {
      alert()
    },
    detail(id) {
      this.$router.push({path: '/visitDetails', query: {id: id}})
    },
    onRefresh() {
      // 重置列表状态
      this.messageList = [];
      this.queryData.pageNum = 1;
      this.onLoad()
    },
    async onSearch() {
      // 重置列表状态
      this.messageList = [];
      this.queryData.pageNum = 1;
      this.pageFinished = false;
      // 触发加载事件，进行搜索
      this.onLoad();
    },
    onLoad() {
      try {
        getCustomerVisitAPI(this.queryData).then(res => {
          if (res.code == 200) {
            if (this.messageList.length < res.total) {
              this.messageList = this.messageList.concat(res.rows); // 将新数据添加到数组中
              this.queryData.pageNum++; // 增加页码
            } else {
              this.pageFinished = true; // 如果没有更多数据，则设置 finished 为 true
            }
            this.pageLoading = false; // 加载状态结束
            this.refreshLoading = false
          }
        })
      } catch (err) {
        console.error(err);
      }
    },
    onAddClick() {
      this.$router.push({path: '/visitAdd'})
    },
    goBack() {
      if (this.$route.query.lastPage) {
        this.$router.push({
          path: this.$route.query.lastPage,
          query: {
            tabIndex: this.$route.query.lastPageTabIndex
          }
        })
      } else {
        this.$router.go(-1)
      }
    },
    convertTime(timeString) {
      // 假设输入的时间格式是 "10:28:35"
      // 首先，我们需要将字符串转换为 Date 对象
      const dateMatch = timeString.match(/(\d{4}-\d{2}-\d{2})/);
      let datestr = dateMatch ? dateMatch[1] : '';
      const date = new Date(timeString);
      // 然后，我们提取小时和分钟
      const hours = date.getHours();
      const minutes = date.getMinutes();
      // 最后，我们将小时和分钟格式化为 "10:28" 格式
      const formattedTime = `${hours}:${minutes < 10 ? '0' + minutes.toString() : minutes}`;
      return datestr + ' ' + formattedTime;
    }
  },
};
</script>

<style scoped>
/* fixed pos-b-100 pos-r-20 z-1 */
.fixed-button {
  position: fixed;
  bottom: 100px; /* 按钮距离底部10px */
  right: 20px; /* 按钮距离右侧10px */
  z-index: 1; /* 确保按钮在其他内容之上 */
}

.hjj {
  display: inline-block;
  line-height: 150%;
}

.divider-small {
  margin: 5px 0;
  transform: scale(1, 3);
}

.task-block {
  margin: 4px 8px 0px 8px;
  border-radius: 20px;
  background-color: rgb(255, 255, 255);
  display: block;
}


</style>
